import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Mail, Phone, Heart, MapPin } from 'lucide-react';

const Footer = () => {
    const QuickLink = ({ to, children }) => (
        <Link
            to={to}
            className="text-gray-400 hover:text-white transition-colors duration-300"
        >
            {children}
        </Link>
    );

    const SocialLink = ({ Icon, href, label }) => (
        <a href={href}
           target="_blank"
           rel="noopener noreferrer"
           aria-label={label}
           className="p-2 rounded-lg hover:bg-white/5
                    transition-all duration-300 group">
            <Icon className="h-5 w-5 text-gray-400 group-hover:text-white
                           transition-all duration-300" />
        </a>
    );

    const ContactItem = ({ Icon, href, label, text }) => (
        <a href={href}
           className="flex items-center space-x-3 text-gray-400 hover:text-white
                    transition-all duration-300 group">
            <Icon className="h-5 w-5" />
            <span className="text-sm">{text}</span>
        </a>
    );

    return (
        <footer className="bg-[#1a1a2e]">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {/* Logo & About */}
                    <div className="space-y-4">
                        <div className="flex items-center space-x-2">
                            <Heart className="h-5 w-5 text-gray-400" />
                            <span className="font-semibold text-lg text-white">CCM</span>
                        </div>
                        <p className="text-gray-400 text-sm leading-relaxed">
                            Dedicated to transforming lives through compassion and community support
                            since 2008.
                        </p>
                        <div className="flex space-x-3 pt-2">
                            <SocialLink
                                Icon={Facebook}
                                href="https://www.facebook.com/CommunityCharitableMinistry/"
                                label="Facebook"
                            />
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div className="space-y-4">
                        <h3 className="text-white font-semibold text-sm">Quick Links</h3>
                        <div className="flex flex-col space-y-2">
                            <QuickLink to="/about">About Us</QuickLink>
                            <QuickLink to="/support">Support Our Mission</QuickLink>
                            <QuickLink to="/news">Latest News</QuickLink>
                            <QuickLink to="/photos">Photo Gallery</QuickLink>
                        </div>
                    </div>

                    {/* Contact */}
                    <div className="space-y-4">
                        <h3 className="text-white font-semibold text-sm">Contact Us</h3>
                        <div className="space-y-3">
                            <ContactItem
                                Icon={Phone}
                                href="tel:(268) 773-7316"
                                label="Phone"
                                text="(268) 773-7316"
                            />
                            <ContactItem
                                Icon={Mail}
                                href="mailto:communitycharitableministry@gmail.com"
                                label="Email"
                                text="communitycharitableministry@gmail.com"
                            />
                        </div>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="mt-12 pt-8 border-t border-white/10">
                    <div className="text-center text-gray-500 text-sm">
                        <p>© {new Date().getFullYear()} Community Charitable Ministry. All rights reserved.</p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;